<template>
  <v-dialog v-model="dialog" persistent :max-width="maxWidth" content-class="public-survey-fun-fact-dialog" :origin="`bottom right`">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text v-if="description">{{ description }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          color="primary"
          elevation="0"
          @click="submit">
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PublicSurveyFunFactDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    submitText: {
      type: String,
      default: 'Submit'
    },
    maxWidth: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
    },
  },
  methods: {
    submit() {
      this.dialog = false
      this.$emit('submit')
    },
  }
}
</script>

<style lang="scss">
@import '@/styles/variables';
.public-survey-fun-fact-dialog {
  margin-left: auto;
  margin-top: auto;
}
</style>